import React from "react";
import "./Section.css";

const Section = ({ seccion, reportInfo }) => {
  if (seccion.nombreseccion === "Información General") {
    return (
      <div className="section">
        <h2>{seccion.nombreseccion}</h2>
        <div className="info-general">
          <p><strong>Empresa Cliente:</strong> {reportInfo.empresaCliente}</p>
          <p><strong>Estado Firma Inspector:</strong> {reportInfo.estadofirmainspector}</p>
          <p><strong>Estado Firma Supervisor:</strong> {reportInfo.estadofirmasupervisor}</p>
          <p><strong>Fecha:</strong> {reportInfo.fecha}</p>
          <p><strong>ID Empresa Cliente:</strong> {reportInfo.idempresacliente}</p>
          <p><strong>ID Inspector:</strong> {reportInfo.idinspector}</p>
          <p><strong>ID Planta:</strong> {reportInfo.idplanta}</p>
          <p><strong>ID Reporte:</strong> {reportInfo.idreporte}</p>
          <p><strong>ID Supervisor:</strong> {reportInfo.idsupervisor}</p>
          <p><strong>ID Tipo Mantenimiento:</strong> {reportInfo.idtipomantenimiento}</p>
          <p><strong>Inspector:</strong> {reportInfo.inspector}</p>
          <p><strong>Observaciones:</strong> {reportInfo.observaciones}</p>
          <p><strong>Planta:</strong> {reportInfo.planta}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="section">
      <p className="section-title">{seccion.nombreseccion}</p>
      {seccion.items.map((item) => (
        <Item key={item.id} item={item} />
      ))}
    </div>
  );
};

const Item = ({ item }) => {
  return (
    <div className="item">
      <p>{item.descripcion}</p>
      {/* Renderiza la respuesta del item si existe */}
      {item.respuesta && <ItemInput item={item} />}
    </div>
  );
};

const ItemInput = ({ item }) => {
  switch (item.idtiporespuesta) {
    case 1: // Boolean
      return <input type="checkbox" checked={item.respuesta} readOnly />;
    case 2: // Numeric
      return <input type="number" value={item.respuesta} readOnly />;
    case 3: // Text
      return <input type="text" value={item.respuesta} readOnly />;
    default:
      return <span>{item.respuesta}</span>;
  }
};

export default Section;